import {Component, OnInit} from '@angular/core';
import {CareerService} from "../../../shared/services/career.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import Swal from 'sweetalert2';
import {FileService} from "../../../shared/services/file.service";
import {JobopeningService} from "../../../shared/services/jobopening.service";

@Component({
    selector: 'app-career',
    templateUrl: './career.component.html',
    styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {
    addCareerForm: FormGroup;
    onFileChanged: any;
    image: any;
    jobOpenings: any;
    jobTitles: any;

    constructor(private CarrerService: CareerService,
                private formBuilder: FormBuilder,
                private fileuploadService: FileService,
                private jobOpeningService: JobopeningService) {
    }

    ngOnInit(): void {
        window.scroll(0, 0);
        this.addCareerForm = this.formBuilder.group({
            'name': ['', Validators.required],
            'email': ['', Validators.required],
            'experience': ['', Validators.required],
            'contact': ['', Validators.required],
            'applied_for': ['', Validators.required],
        });
        this.get();
    }

    get() {
        this.jobOpeningService.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.jobOpenings = data['data'];
                this.jobTitles = this.jobOpenings.map((item) => item.title);
            }
        })
    }

    submit() {
        console.log(123);
        if (!this.addCareerForm.valid || this.image == null) {
            console.log(321);
            this.showWarningAlert();
            return;
        }
        const params = {
            'name': this.addCareerForm.value.name,
            'email': this.addCareerForm.value.email,
            'experience': this.addCareerForm.value.experience,
            'contact': this.addCareerForm.value.contact,
            'applied_for': this.addCareerForm.value.applied_for,
            'file_id': this.image ? this.image?.id : ''
        }
        console.log(params);
        this.CarrerService.create(params).subscribe(data => {
            this.showAlert();
            this.addCareerForm.reset();
        }, error => {
            console.log(error.error);
        })
    }

    showAlert() {
        Swal.fire({
            title: 'Your form Submitted!',
            text: 'We may contact you as soon as possible',
            icon: 'success',
            confirmButtonText: 'OK',
        });
    }

    showWarningAlert() {
        Swal.fire({
            title: 'Field Missing!',
            icon: 'info',
            html: 'All Fields are required, please fill are fields correctly!',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok!',
            // cancelButtonText: '<i class="fa fa-check"></i> Cancel',
        });
    }

    onFileChange(e) {
        this.onFileChanged = e;
        this.fileuploadService.fileUpload({
            'type': 'RESUME',
            'fileType': 'NORMAL',
        }, this.onFileChanged).subscribe(data => {
            this.image = data['data'];
            console.log(data, this.image);
        }, error => {
            // this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    goTo(url: any) {
        window.open(url, '_blank');
    }

    goToTop() {
        window.scrollTo(0, 0);
    }
}
